import { useApi } from "utils";
import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { DetailBillServiceSchema } from "../types";

type useGetListDetailBillServiceProps = {
  bill_id: number
}

export const useGetListDetailBillService = ({ bill_id }: useGetListDetailBillServiceProps) => {
  const api = useApi();
  const [data, setData] = useState<DetailBillServiceSchema[]>([]);
  const [isLoading, setLoading] = useState(true)

  const fetchUrl = () => api.post(`/paymentbill/getdata-bill-service-byidbill?bill_id=${bill_id}`)

  const fetchData = () => {
    setLoading(true);

    fetchUrl()
    .then((res: SuccessFetch<{ payload: DetailBillServiceSchema[] }>) => setData(res.data.payload))
    .catch(() => setData([]))
    .finally(() => setLoading(false));
  }

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData([]);
      setLoading(true);
    }

    // eslint-disable-next-line
  }, [bill_id]);

  return { data, isLoading, refetch }
}